module.exports = __webpack_public_path__ + "static/media/icon2.defc33ab.svg";